<template>
  <v-layout>
    <v-dialog :value="dialog" @click:outside="$emit('updateDialog', false)" max-width="720px">
      <template v-slot:activator="{ on }" v-if="button_name">
        <v-btn color="primary" class="mb-5" dark v-on="on" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card v-if="item">
        <v-form v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <p class="caption grey--text text--darken-1">
              Cuando una línea del extracto contiene el texto indicado, en la conciliación se sugiere registrarla con la plantilla
              de tesorería elegida (por ejemplo: <b>907176</b> o <b>IMPUESTO DEBITO - LEY 25413</b> → plantilla "Impuesto Ley 25.413").
            </p>
            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  v-model="item.match_field"
                  :items="field_options"
                  item-text="name"
                  item-value="id"
                  label="Buscar en*"
                  name="match_field"
                  data-vv-as="campo"
                  v-validate="'required'"
                  :disabled="isViewModal()"
                ></v-select>
                <span class="red--text caption">{{ errors.first("match_field") }}</span>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="item.pattern"
                  label="Texto a buscar*"
                  name="pattern"
                  data-vv-as="texto"
                  v-validate="'required|max:150'"
                  hint="Coincidencia parcial, sin distinguir mayúsculas"
                  persistent-hint
                  :disabled="isViewModal()"
                ></v-text-field>
                <span class="red--text caption">{{ errors.first("pattern") }}</span>
              </v-col>
              <v-col cols="12" md="6">
                <v-combobox
                  v-model="item.tesoreria_movement_template"
                  :items="templates"
                  item-text="name"
                  item-value="id"
                  label="Plantilla de tesorería*"
                  name="tesoreria_movement_template"
                  data-vv-as="plantilla"
                  v-validate="'required|combobox_required'"
                  :disabled="isViewModal()"
                ></v-combobox>
                <span class="red--text caption">{{ errors.first("tesoreria_movement_template") }}</span>
              </v-col>
              <v-col cols="12" md="6">
                <v-combobox
                  v-model="item.money_account"
                  :items="money_accounts"
                  item-text="name"
                  item-value="id"
                  label="Cuenta bancaria"
                  hint="Vacío = aplica a todas las cuentas"
                  persistent-hint
                  clearable
                  :disabled="isViewModal()"
                ></v-combobox>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="item.enabled" label="Habilitada" hide-details :disabled="isViewModal()"></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" v-if="!isViewModal()" :loading="loading">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Constant from "@/constants/sections";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import { generalService } from "@/libs/ws/generalService";
import { tesoreriaMovementTemplateService } from "@/libs/ws/tesoreriaMovementTemplateService";
import { conciliacionReglaService } from "@/libs/ws/conciliacionReglaService";

export default {
  mixins: [ModalGenericMixin],
  props: {
    service: Object,
    modal_title: String,
    dialog: Boolean,
    item: Object,
    button_name: String,
    formBtn: String,
  },
  data() {
    return {
      field_options: [],
      templates: [],
      money_accounts: [],
    };
  },
  watch: {
    item() {
      this.$emit("updateItem", this.item);
    },
    dialog() {
      this.errors.clear();
    },
  },
  mounted() {
    conciliacionReglaService.fields().then((r) => { this.field_options = r.result || []; }).catch(() => {});
    tesoreriaMovementTemplateService.filter().then((r) => { this.templates = r.result || []; }).catch(() => {});
    generalService.setSection(Constant.SECTION_MONEY_ACCOUNTS);
    generalService.filter({ account_type: "B" }).then((r) => { this.money_accounts = r.result || []; }).catch(() => {});
  },
  methods: {
    isViewModal() {
      return this.formBtn == "";
    },
    createItem(e) {
      this.$validator.validate().then((valid) => {
        if (!valid) return;
        e.preventDefault();
        this.loading = true;
        const data = {
          id: this.item.id,
          match_field: this.item.match_field,
          pattern: this.item.pattern,
          enabled: this.item.enabled,
          tesoreria_movement_template: this.item.tesoreria_movement_template ? { id: this.item.tesoreria_movement_template.id } : null,
          money_account: this.item.money_account ? { id: this.item.money_account.id } : null,
        };
        const request = this.item.id > 0 ? this.service.update(data) : this.service.create(data);
        request
          .then((r) => {
            if (r.status) {
              this.$toast.success("La " + this.modal_title + (this.item.id > 0 ? " se modificó correctamente." : " se creó correctamente."), "OK");
              this.$emit("loadList");
              this.$emit("updateDialog", false);
            } else {
              this.$toast.error(this.parseErrorResultValidation(r), "Error");
            }
          })
          .catch(() => { this.$toast.error("Error al guardar.", "Error"); })
          .finally(() => { this.loading = false; });
      });
    },
  },
};
</script>
